import {
  reservationsCreatePath,
  reservationsTodaysPath,
  reservationsUpcomingPath,
  reservationsPendingPath,
  reservationsArchivedPath,
  reservationsUpcomingEventsPath,
  reservationsROItemCreatePath,
  reservationsROItemListPath,
  reservationsROPicklistCreatePath,
  reservationsROPicklistListPath,
  reservationsOrderedItemsReportsPath
} from '../../../routes/Paths';

export const NAV_KEYS = {
  CREATE: 'create',
  TODAYS: 'todays',
  UPCOMING: 'upcoming',
  PENDING: 'pending',
  ARCHIVED: 'archived',
  UPCOMING_EVENTS: 'upcoming-events',
  GUEST_CHOICES: 'guest-choices',
  RO_ITEM_CREATE: 'ro-item-create',
  RO_ITEM_LIST: 'ro-item-list',
  RO_PICKLIST_CREATE: 'ro-picklist-create',
  RO_PICKLIST_LIST: 'ro-picklist-list',
  REPORTS: 'reports',
  ORDERED_ITEMS_REPORT: 'ordered-items-report'
};

export const navKeysByPath = {
  [reservationsCreatePath]: NAV_KEYS.CREATE,
  [reservationsTodaysPath]: NAV_KEYS.TODAYS,
  [reservationsUpcomingPath]: NAV_KEYS.UPCOMING,
  [reservationsPendingPath]: NAV_KEYS.PENDING,
  [reservationsArchivedPath]: NAV_KEYS.ARCHIVED,
  [reservationsUpcomingEventsPath]: NAV_KEYS.UPCOMING_EVENTS,
  [reservationsROItemCreatePath]: NAV_KEYS.RO_ITEM_CREATE,
  [reservationsROItemListPath]: NAV_KEYS.RO_ITEM_LIST,
  [reservationsROPicklistCreatePath]: NAV_KEYS.RO_PICKLIST_CREATE,
  [reservationsROPicklistListPath]: NAV_KEYS.RO_PICKLIST_LIST,
  [reservationsOrderedItemsReportsPath]: NAV_KEYS.ORDERED_ITEMS_REPORT
};
